<template>
<div class="chapter">
<div class="inner_page">
<p class="toch"><b>Contents</b></p>
<p class="toc"><a href="#/Book1/1">1</a></p>
<p class="toc"><a href="#/Book1/2">2</a></p>
<p class="toc"><a href="#/Book1/3">3</a></p>
<p class="toc"><a href="#/Book1/4">4</a></p>
<p class="toc"><span href="#/Book1/5" title="Link target outside of Sample">5</span></p>
<p class="toc"><span href="#/Book1/6" title="Link target outside of Sample">6</span></p>
<p class="toc"><span href="#/Book1/7" title="Link target outside of Sample">7</span></p>
<p class="toc"><span href="#/Book1/8" title="Link target outside of Sample">8</span></p>
<p class="toc"><span href="#/Book1/9" title="Link target outside of Sample">9</span></p>
<p class="toc"><span href="#/Book1/10" title="Link target outside of Sample">10</span></p>
<p class="toc"><span href="#/Book1/11" title="Link target outside of Sample">11</span></p>
<p class="toc"><span href="#/Book1/12" title="Link target outside of Sample">12</span></p>
<p class="toc"><span href="#/Book1/13" title="Link target outside of Sample">13</span></p>
<p class="toc"><span href="#/Book1/14" title="Link target outside of Sample">14</span></p>
<p class="toc"><span href="#/Book1/15" title="Link target outside of Sample">15</span></p>
<p class="toc"><span href="#/Book1/16" title="Link target outside of Sample">16</span></p>
<p class="toc"><span href="#/Book1/17" title="Link target outside of Sample">17</span></p>
<p class="toc"><span href="#/Book1/18" title="Link target outside of Sample">18</span></p>
<p class="toc"><span href="#/Book1/19" title="Link target outside of Sample">19</span></p>
<p class="toc"><span href="#/Book1/20" title="Link target outside of Sample">20</span></p>
<p class="toc"><span href="#/Book1/21" title="Link target outside of Sample">21</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4126ee84